import moment from "moment";
import { getStaffManualCheckoutActor } from "./staff-attendance-session-helper";
import { getStaffScanLocation } from "./staff-scan-location-helper";


const ACTIONS = [ "check_in", "check_out" ];
const RESULTS_BY_STATUS = {
    success: "accepted",
    warning: "ignored",
    rejected: "rejected",
};
const REASONS_BY_ENUM = {
    WITHIN_RADIUS: "within_radius",
    OUTSIDE_RADIUS: "outside_radius",
    OUTSIDE_SCHEDULE: "outside_schedule",
    PERMISSION_DENIED: "location_permission_denied",
    CAMERA_PERMISSION_DENIED: "camera_permission_denied",
    LOCATION_UNAVAILABLE: "location_unavailable",
    QR_INVALID: "invalid_qr",
    ALREADY_CHECKED_IN: "duplicate_scan",
    NO_OPEN_SESSION: "no_open_session",
    DEVICE_CONFLICT: "same_device",
    MANUAL_CLOSE: "manual_close",
};

const safeValue = (value, supported) => (
    supported.includes(value) ? value : "unknown"
);

export const getStaffAuditAction = (value) => safeValue(value, ACTIONS);
export const getStaffAuditResult = (status) => (
    Object.prototype.hasOwnProperty.call(RESULTS_BY_STATUS, status) ?
        RESULTS_BY_STATUS[ status ] :
        "unknown"
);
export const getStaffAuditReason = (value) => (
    Object.prototype.hasOwnProperty.call(REASONS_BY_ENUM, value) ?
        REASONS_BY_ENUM[ value ] :
        "unknown"
);

export const getStaffAuditReasonDetail = (auditLog) => (
    auditLog?.reason === "MANUAL_CLOSE" ? getStaffManualCheckoutActor(auditLog) :
        auditLog?.reason === "DEVICE_CONFLICT" ? auditLog?.detail : undefined
);

export const getStaffAuditWorkerName = (auditLog) => (
    `${ auditLog?.relUser?.name || "" } ${ auditLog?.relUser?.surname || "" }`.trim()
);

export const getStaffAuditSubcontractorTitle = (auditLog) => (
    auditLog?.getSubcontractor?.title || auditLog?.relUser?.subcontractor?.title || "—"
);

export const getStaffAuditDevice = (auditLog) => ({
    platform: auditLog?.platform || "—",
    deviceUUID: auditLog?.device_uuid || "—",
});

export const getStaffAuditScanLocation = (auditLog) => {
    const reason = getStaffAuditReason(auditLog?.reason);

    return getStaffScanLocation({
        id: auditLog?.id,
        created_at: auditLog?.created_at,
        has_location: auditLog?.has_location,
        scan_latitude: auditLog?.latitude,
        scan_longitude: auditLog?.longitude,
        getDistanceFromZone: auditLog?.getDistanceFromZone,
        zone_latitude: auditLog?.zone_latitude,
        zone_longitude: auditLog?.zone_longitude,
        zone_radius: auditLog?.zone_radius,
        reason: auditLog?.reason,
        result: reason === "outside_radius" ? "outside_zone" : undefined,
    }, auditLog?.relUser);
};

export const formatStaffAuditDateTime = (value) => (
    value && moment(value, [ "YYYY-MM-DD HH:mm:ss", moment.ISO_8601 ], true).isValid() ?
        moment(value, [ "YYYY-MM-DD HH:mm:ss", moment.ISO_8601 ], true).format("DD.MM.YYYY, HH:mm:ss") :
        "—"
);

const StaffAuditLogPresentationHelper = {
    getAction: getStaffAuditAction,
    getResult: getStaffAuditResult,
    getReason: getStaffAuditReason,
    getReasonDetail: getStaffAuditReasonDetail,
    getWorkerName: getStaffAuditWorkerName,
    getSubcontractorTitle: getStaffAuditSubcontractorTitle,
    getDevice: getStaffAuditDevice,
    getScanLocation: getStaffAuditScanLocation,
    formatDateTime: formatStaffAuditDateTime,
};

export default StaffAuditLogPresentationHelper;
